
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4 5h12v2H4V5zm17 0h2v18.688l2.594-2.594L27 22.5l-4.281 4.313-.719.688-.719-.688L17 22.5l1.406-1.406L21 23.688V5zM4 9h10v2H4V9zm0 4h8v2H4v-2zm0 4h6v2H4v-2zm0 4h4v2H4v-2zm0 4h2v2H4v-2z"}})])
          )
        }
      }
    